module.exports = __webpack_public_path__ + "img/LYB.036cbe69.svg";